export enum ValidatorKeyEnum {
  GtNegOne = "GtNegOne",
  GtZero = "GtZero",
  GteZero = "GteZero",
  LtOne = "LtOne",
  LteOne = "LteOne",
}
